<div class="status" [ngClass]="'status--'.concat(params.value.toLowerCase())">
  {{ params.value }}
</div>
